import type { ReferentialUserState } from "./referential-user-states.type";
import type { UseReferentialOptions } from "@/entities/referential";

import { useReferential, REFERENTIAL_NAMES } from "@/entities/referential";

export const useReferentialUserStates = (
  options?: UseReferentialOptions<ReferentialUserState[]>
) => {
  const { data: userStates = [], ...result } = useReferential<
    ReferentialUserState[]
  >(REFERENTIAL_NAMES.USER, options);

  return {
    ...result,
    userStates,
  };
};
